import { useEffect, useState } from 'react'
import axios from 'axios'
import { Order } from '../../../../models'

export default function useOrder({ email, orderId }) {
  const [order, setOrder] = useState()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const fetchOrder = async () => {
      setIsLoading(true)

      await axios.post('/carts/set_cart', { email })

      Order
        .includes({ cart: { orderPackages: [{ apiOption: ['imageTypes', 'package'] }, { sheets: ['imageType', 'pose'] }] } })
        .where({ forEmail: [orderId, email] })
        .first()
        .then((res) => {
          if (!res.data) return

          setOrder(res.data)
        })
        .finally(() => setIsLoading(false))
    }

    fetchOrder()
  }, [email, orderId])

  return { data: order, isLoading }
}
